/**
 * useMarketHours — small hook that returns whether NSE cash market is
 * currently open (IST Mon-Fri, 09:15 - 15:30). Re-checks every 30s so
 * components don't show a stale "LIVE" badge.
 *
 * Public holidays aren't tracked client-side (would need a server
 * calendar) — the badge stays on but no harm done since intraday cache
 * simply stops updating on holidays.
 */
import { useEffect, useState } from "react";

function compute() {
  // Get current time in IST regardless of the user's local timezone.
  const now = new Date();
  const ist = new Date(
    now.toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
  );
  const day = ist.getDay(); // 0 = Sunday, 6 = Saturday
  if (day === 0 || day === 6) return false;
  const minutes = ist.getHours() * 60 + ist.getMinutes();
  const open = 9 * 60 + 15;
  const close = 15 * 60 + 30;
  return minutes >= open && minutes <= close;
}

export default function useMarketHours() {
  const [open, setOpen] = useState(compute);
  useEffect(() => {
    const id = setInterval(() => setOpen(compute()), 30000);
    return () => clearInterval(id);
  }, []);
  return open;
}
